// Parses a fabricator settings JSON string (e.g. "wizardSettings", "receiptSettings", "aiSettings").
// Returns an empty object when the value is missing or isn't valid JSON, so the Account page doesn't crash.
export const parseSettingsJson = <T extends object = Record<string, any>>(settingsJson?: string | null, fieldName = "settings"): T => {
  if (!settingsJson) {
    return {} as T;
  }
  try {
    return JSON.parse(settingsJson) || ({} as T);
  } catch (e) {
    console.error(`parseSettingsJson: invalid ${fieldName} JSON`, settingsJson, e);
    return {} as T;
  }
};
